import React, { useState , useEffect} from 'react'
import { Dropdown } from 'semantic-ui-react'
import { generatePdfManually ,getWarehouseDetails} from '../../commonApis'
import { LoaderPopup } from '../LoaderPopup';
import CertDropdownModal from './certDropdownModal';
import { get } from 'lodash';


const CertDropdown = (props) => {


  let filerCode = get(props, 'kxUser.userInfo.brokerAdditionalInfo.filerCode', '');
  let countryOfBusiness = get(props, 'kxUser.userInfo.brokerAdditionalInfo.countryCode', '')
  



  const [toggleLoader, setToggleLoader] = useState(false)
  const [loaderMsg, setLoaderMessage] = useState('Processing...')
  const [selectedType, setSelectedType] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [warehouseID, setWarehouseID] = useState('');  



  const handleItemClick = (type) => {
    setSelectedType(type);
  };

  const toggleLoaderFunc = (msg, timer) => {
    let time = timer || 3000
    setToggleLoader(true)
    setLoaderMessage(msg)
    setTimeout(() => {
      setToggleLoader(false)
      setLoaderMessage('Loading...')
    }, time)
  }

  const updateWarehouseID = (warehouseID) => {
    setWarehouseID(warehouseID)
   };


  const clickHandler = (type) => {
    toggleLoaderFunc(`Generating ${type} document...`)
    let payload = {
      pdfType: `CLIENT_PDF_${type}`,
      shipmentId: props.shipId,
      addDocumentNew: 'TRUE',
      countryCode: 'ES',
    }
    if (selectedType === 'LAME') {
      payload.warehouseIdForLame = warehouseID
    }

    generatePdfManually(payload)
      .then((res) => {
        toggleLoaderFunc('Please wait...')
        if (res?.data?.eventMessage?.code === 400) {
          toggleLoaderFunc(`Failed to generate ${type} document, something went wrong.`)
        } else {
          toggleLoaderFunc(`${type} Document Generated successfully`)
        }
      })
      .catch((err) => {
        toggleLoaderFunc(`Failed to generate ${type} document`)
      })
  }

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedType === "LAME") {
          const response = await getWarehouseDetails({ filerCode, countryOfBusiness })
          setApiData(response?.data?.eventMessage?.partyInfo)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
  
    fetchData();
  }, [selectedType]);

  return (
    <>
      <Dropdown text='Generate Doc' style={{ fontSize: '12px' }}>
        <Dropdown.Menu>
            <Dropdown.Item text='LAME' onClick={() => handleItemClick('LAME')} />
            <Dropdown.Item text='EUR1' onClick={() => handleItemClick('EUR1')} />
            <Dropdown.Item text='RMT' onClick={() => handleItemClick('RMT')} />

              
        </Dropdown.Menu>
      </Dropdown>


      <CertDropdownModal
        open={!!selectedType}
        onClose={() => setSelectedType(null)}
        selectedType={selectedType}
        apiData={apiData}
        onSubmit={clickHandler} 
        updateWarehouseID={updateWarehouseID}
        />

      {toggleLoader && <LoaderPopup loaderMsg={loaderMsg} />}

    </>
  )
}

export default CertDropdown